<div class="pm-screen">

  <!-- ── Sidebar ── -->
  <aside class="pm-sidebar">
    <nav class="pm-nav">
      <button class="pm-nav-btn" [class.active]="view === 'manager'" (click)="view = 'manager'">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
        Projects
        <span class="pm-nav-count" *ngIf="!loading">{{ savedProjects.length }}</span>
      </button>
      <button class="pm-nav-btn" [class.active]="view === 'new'" (click)="openNew()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>
        New Project
      </button>
      <button class="pm-nav-btn" (click)="importFile()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
        Import .pxlvd
      </button>
    </nav>
  </aside>

  <!-- ── Main ── -->
  <main class="pm-main">

    <!-- Loading -->
    <div *ngIf="loading" class="pm-empty">
      <div class="pm-empty-icon">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg>
      </div>
      <p>Loading your projects…</p>
    </div>

    <!-- ── Project Manager view ── -->
    <ng-container *ngIf="!loading && view === 'manager'">
      <div class="pm-header">
        <h1 class="pm-title">Your Projects</h1>
        <button class="pm-action-btn" (click)="openNew()">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>
          New Project
        </button>
      </div>

      <!-- Empty state -->
      <div *ngIf="savedProjects.length === 0" class="pm-empty">
        <div class="pm-empty-icon">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M12 8v8M8 12h8" stroke-width="1.5"/></svg>
        </div>
        <p>No saved projects yet.</p>
        <button class="pm-cta-btn" (click)="openNew()">Create your first project</button>
      </div>

      <!-- Project grid -->
      <div *ngIf="savedProjects.length > 0" class="pm-grid">
        <div *ngFor="let p of savedProjects" class="pm-card"
          [class.renaming]="renamingId === p.id"
          [class.deleting]="deleteConfirmId === p.id"
          (click)="openProject(p)">

          <!-- Thumbnail -->
          <div class="pm-card-thumb">
            <img *ngIf="p.thumbnail" [src]="p.thumbnail" alt="">
            <svg *ngIf="!p.thumbnail" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1"><rect x="3" y="3" width="18" height="18" rx="2"/></svg>
            <!-- Open overlay -->
            <div class="pm-card-open-overlay">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
              Open
            </div>
          </div>

          <!-- Name (rename mode) -->
          <div class="pm-card-meta">
            <div *ngIf="renamingId !== p.id" class="pm-card-name">{{ p.name }}</div>
            <input *ngIf="renamingId === p.id" id="rename-input" class="pm-rename-input"
              [(ngModel)]="renameValue"
              (click)="$event.stopPropagation()"
              (keydown.enter)="commitRename(p)"
              (keydown.escape)="cancelRename()"
              (blur)="commitRename(p)">
            <div class="pm-card-date">{{ formatDate(p.updatedAt) }}</div>
          </div>

          <!-- Actions -->
          <div class="pm-card-actions" *ngIf="deleteConfirmId !== p.id">
            <button class="pm-icon-btn" (click)="startRename(p, $event)" title="Rename">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            </button>
            <button class="pm-icon-btn pm-icon-btn-danger" (click)="confirmDelete(p, $event)" title="Delete">
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
            </button>
          </div>

          <!-- Delete confirm -->
          <div class="pm-delete-confirm" *ngIf="deleteConfirmId === p.id" (click)="$event.stopPropagation()">
            <span>Delete "{{ p.name }}"?</span>
            <div class="pm-confirm-btns">
              <button class="pm-confirm-yes" (click)="executeDelete(p, $event)">Delete</button>
              <button class="pm-confirm-no" (click)="cancelDelete($event)">Cancel</button>
            </div>
          </div>

        </div>
      </div>
    </ng-container>

    <!-- ── New Project view ── -->
    <ng-container *ngIf="!loading && view === 'new'">
      <div class="pm-header">
        <h1 class="pm-title">New Project</h1>
      </div>
      <div class="pm-form">
        <div class="pm-field">
          <label class="pm-label">Project Name</label>
          <input type="text" class="pm-input" [(ngModel)]="projectName"
            placeholder="Untitled Project" autofocus (keydown.enter)="create()">
        </div>
        <div class="pm-field">
          <label class="pm-label">Canvas Resolution</label>
          <div class="pm-res-grid">
            <button *ngFor="let r of resPresets" type="button" class="pm-res-card"
              [class.active]="isSameResCard(selectedRes, r)" (click)="selectRes(r)">
              <div class="pm-res-preview">
                <div class="pm-res-inner"
                  [class.pm-res-inner--tall]="isPreviewTallerThanWide(r)"
                  [class.pm-res-inner--wide]="!isPreviewTallerThanWide(r)"
                  [style.aspect-ratio]="previewAspectRatio(r)"></div>
              </div>
              <div class="pm-res-info">
                <span class="pm-res-label">{{ r.label }}</span>
                <span class="pm-res-dims">{{ displayDimsText(r) }}</span>
              </div>
            </button>
          </div>
          <div class="pm-custom-dims" *ngIf="isCustomPreset(selectedRes)">
            <div>
              <label for="pm-custom-w">Width</label>
              <input id="pm-custom-w" type="number" class="pxl-input" [(ngModel)]="customW" [min]="CANVAS_DIM_MIN" [max]="CANVAS_DIM_MAX">
            </div>
            <div>
              <label for="pm-custom-h">Height</label>
              <input id="pm-custom-h" type="number" class="pxl-input" [(ngModel)]="customH" [min]="CANVAS_DIM_MIN" [max]="CANVAS_DIM_MAX">
            </div>
          </div>
        </div>
        <div class="pm-form-actions">
          <button class="pm-submit-btn" (click)="create()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>
            Create Project
          </button>
          <button class="pm-cancel-btn" *ngIf="savedProjects.length > 0" (click)="view = 'manager'">
            Cancel
          </button>
        </div>
      </div>
    </ng-container>

  </main>
</div>
